module.exports = __webpack_public_path__ + "static/media/icon-check.ba447259.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-check.svg
// module id = 265
// module chunks = 3